import PropTypes from "prop-types"
import { GridColumnMenu } from "@mui/x-data-grid-premium"
import { MenuItem, ListItemIcon, ListItemText } from "@mui/material"
import { ArrowUpward, ArrowDownward } from "@mui/icons-material"
import classNames from "classnames"
import { getSortOptions, isAbsoluteSort } from "../helpers"

function CustomSortMenu(props) {
  const { colDef, onClick, onSortChange, currentSortField, currentSortDirection } = props
  const isTextColumn = colDef.type === "string"
  const isSortedColumn = currentSortField === colDef.field

  const sortOptions = getSortOptions(isTextColumn).map(option => ({
    ...option,
    icon: option.icon === "asc" ? ArrowUpward : ArrowDownward,
  }))

  const handleSortClick = (direction) => {
    onSortChange?.(colDef.field, direction)
    onClick()
  }

  return (
    <>
      {sortOptions.map(({ direction, label, icon: IconComponent }) => {
        const isActive = isSortedColumn && currentSortDirection === direction

        return (
          <MenuItem
            key={direction}
            onClick={() => handleSortClick(direction)}
            selected={isActive}
          >
            <ListItemIcon className={classNames("custom-sort-menu-icon", {
              "abs-sort-icon": isAbsoluteSort(direction),
            })}
            >
              <IconComponent />
            </ListItemIcon>
            <ListItemText primary={label} />
          </MenuItem>
        )
      })}
    </>
  )
}

CustomSortMenu.propTypes = {
  colDef: PropTypes.shape({
    field: PropTypes.string.isRequired,
    type: PropTypes.string,
    sortable: PropTypes.bool,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  onSortChange: PropTypes.func,
  currentSortField: PropTypes.string,
  currentSortDirection: PropTypes.string,
}

export function CustomColumnMenu(props) {
  const { onSortChange, currentSortField, currentSortDirection, ...gridColumnMenuProps } = props
  return (
    <GridColumnMenu
      {...gridColumnMenuProps}
      slots={{
        customSortMenu: CustomSortMenu,
        // Turn off default features other than pinning
        columnMenuFilterItem: null,
        columnMenuColumnsItem: null,
        columnMenuAggregationItem: null,
        columnMenuGroupingItem: null,
        columnMenuPivotItem: null,
      }}
      slotProps={{
        customSortMenu: {
          onSortChange,
          currentSortField,
          currentSortDirection,
          displayOrder: 0,
        },
      }}
    />
  )
}

CustomColumnMenu.propTypes = {
  onSortChange: PropTypes.func,
  currentSortField: PropTypes.string,
  currentSortDirection: PropTypes.string,
}
